import { createUseStyles } from 'react-jss'
import { colors } from '#base/js/variables.style'
import { BORDER_WIDTH } from './forest.style'

export const style = {
  border: {
    fill: 'none',
    stroke: colors.gray,
    strokeWidth: BORDER_WIDTH
  },
  analysisLabel: {
    textTransform: 'uppercase',
    fontSize: 13,
    fill: colors.gray
  },
  dropshadow: {
    filter: 'url(#dropshadow)'
  },
  selectedBackground: {
    fill: 'white',
    stroke: colors.brandDark,
    strokeWidth: 1
  },
  pointGroup: {
    cursor: 'default'
  }
}

export const useStyles = createUseStyles(style)
